module.exports = {
  active: 0,
  inActive: 1,
  blocked: 2,
};
